import { createSelector } from 'reselect';
import { BookView } from '@Selectors/publication/book/view/book.view';
import { getBooksSelector } from '@Selectors/publication/book/selector/get-books.selector';

export const booksPresenter = createSelector(
  [getBooksSelector],
  (books): Array<BookView> => {
    return books.map((item) => {
      return new BookView({
        id: item.id,
        name: item.name,
        armyLogo: item.armyLogo,
        armyName: item.armyName,
        sections: [],
      });
    });
  },
);
